<template>
  <div class="NavigationBar">
    <div class="content">
      <div>
        <img class="icon" src="../assets/images/navbar-icon.png">
      </div>
      <ul class="nav_tab">
        <li class="tab-item">
          <router-link to="/home">首页</router-link>
        </li>
        <li class="tab-item">
          <router-link to="/about">关于我们</router-link>
        </li>
        <li class="tab-item">
          <router-link to="/products">产品与服务</router-link>
        </li>
        <li class="tab-item">
          <router-link to="/news">新闻动态</router-link>
        </li>
        <li class="tab-item">
          <router-link to="/join">加入我们</router-link>
        </li>
        <li class="tab-item">
          <router-link to="/contact">联系我们</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavigationBar",

  computed: {},
  methods: {}
};
</script>

<style lang="scss">
.NavigationBar {
    width: 100%;
    position: fixed;
    right: 0;
    left: 0;
    top: 0;
    z-index: 1000;
    height: 50px;
  .content {
    width: 1200px;
    margin: auto;
    z-index: 1100;
    display: flex;
    justify-content: space-between;
  }

  .icon {
    width: 30px;
    height: 30px;
    margin-top: 13px;
  }
  .nav_tab {
    display: flex;
    list-style: none;
    padding: 0;
    .tab-item {
      margin: 16px 50px 0 0px;
      .tab-item:last-child {
        margin: 16px 50px 0 0px;
      }
    }
  }
  a {
    text-decoration: none;
    font-size: 16px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    color: white;
  }
}
</style>
